
    //localStorage.removeItem('mxpr-favorites');
    var setbox = document.querySelector("#favorite-items");
	var get = localStorage.getItem('mxpr-favorites');
    
    if (get != "null") {
	var data = JSON.parse(get);
      
    if (data.length > 0) {
	for (var i = 0; i < data.length; i ++) {
	
		var price = data[i].price;
		var img = data[i].imageUrl;
		var title = data[i].title + data[i].variantTitle;
        var url = data[i].url;
        var tags = data[i].tags;

        var p = String(price).slice(0, -2);
        p = Math.ceil(Number(p) * 1.1);
        p = String(p);
      
        var _size = p.length;
        if (_size > 3) {
            var count = 1; 
            if (p.length % 3 == 0) {
              _size -= 1;
            } 
            for (var l = 0; l < Math.floor(_size/3); l ++) {
                  p = p.slice(0, p.length - ((3 * count) + (count - 1))) + "," + p.slice(p.length - ((3 * count) + (count - 1)));
                  count ++;
            }
        }
        price = p + "円<span class=\"tax\">（税込）</span>";
      
        var _flex = document.createElement('div');
        _flex.classList.add("flex", "mg-r10");
        if (i > 0) {
          _flex.classList.add("pd-t_1rm");
        }
      
          var _img = document.createElement('img');
          _img.src = img;
          _img.alt = "title";
          _img.classList.add("w_30per", "mg-r10");
          _flex.appendChild(_img);
      
          var _wrap = document.createElement('div');
            _wrap.classList.add("flex", "justify-content-space-between", "wrap");

            var _inwrap = document.createElement('div');
            _inwrap.classList.add('w_100per');

              var _a = document.createElement('a');
              _a.href = url;
              
                var _title = document.createElement('h2');
                _title.innerHTML = title;
                _a.appendChild(_title);
  
              _inwrap.appendChild(_a);
          
              var _price = document.createElement('p');
              _price.innerHTML = price;
              _inwrap.appendChild(_price);

              /*
              <button data-handle="sauna-7008-340601" data-variant-id="41556648952014" data-quantity="1" 
              data-save-for-later="false" data-customer-id="" class="mxpr-favorites-cart-add " 
              onclick="handleAddToCart(this)">カートに追加する</button>
              */
                
              var _flex2 = document.createElement('div');
              _flex2.classList.add("toflex");
  
                var label = ["_label_即日発送", "_label_送料有", "_label_メール便送料無料", "_label_送料無料"];
                var c = 0;
                for (var y = 0; y < label.length; y ++) {
                  var _go = false;
                  let searchString;
                  (function(gety){
                    searchString = label[y];
                    if (y == 2) {
                      if (data[i].price > 361800) {
                          _go = true;
                      }
                    }
                  }(y));
  
                  let containsSearchString = tags.some(item => item.includes(searchString));
                  if (containsSearchString || _go) {

                      if (searchString.slice(7) == "送料有") {
                        break;
                      }
                      var _tag = document.createElement('div');    
                      _tag.classList.add("f_wh", "f_bld", "pd_03rm", "ls_02em", "txt_c");
                      if (searchString.slice(7) == "即日発送") {
                          _tag.classList.add("bg_yl");
                      } else {
                          _tag.classList.add("bg_prd");
                      }
                    
                      if (c > 0) {
                          _tag.classList.add("mg_l10");
                      }
                    
                      _tag.innerHTML = searchString.slice(7);
                      _flex2.appendChild(_tag);
                      if (searchString.slice(7) == "メール便送料無料") {
                          break;
                      }
                      c += 1;
                  }
                }

            _inwrap.appendChild(_flex2);
            _wrap.appendChild(_inwrap);

            //
             (function(capturedI) {

              var _wrap2 = document.createElement('div');
              _wrap2.classList.add("toflex", "justify-content-space-right");
              //
              var _flex3 = document.createElement('div');
              _flex3.classList.add("toflex", "align-items_center", "mg-t_1rm");

                  var _input = document.createElement('input');
                  _input.classList.add("input_" + capturedI, "txt_c", "w30px", "bdunset", "bdbottom", "curtaddinput", "mg-r10px");
                  _input.value = 1;
                  _input.dataset.setclass = ".btn_" + capturedI;
                  _input.dataset.thisclass = ".input_" + capturedI;
                  _input.addEventListener('change', function(event) {
                      inputcheck(_input.dataset.setclass, _input.dataset.thisclass);
                  }); 
                  _flex3.appendChild(_input);
               
                  var _pricedown = document.createElement('button');
                　_pricedown.dataset.setclass = ".btn_" + capturedI;
                  _pricedown.dataset.inputclass = ".input_" + capturedI;
                  _pricedown.classList.add("w30px", "h30px", "f_wh", "bg_bk", "br_30", "mg5px");
                  _pricedown.addEventListener('click', function(event) {
                      valuedown(_pricedown.dataset.inputclass, _pricedown.dataset.setclass);
                  });
                  _pricedown.innerHTML = "-";
                  _flex3.appendChild(_pricedown);
              
                  var _priceup = document.createElement('button');
                  _priceup.dataset.setclass = ".btn_" + capturedI;
                  _priceup.dataset.inputclass = ".input_" + capturedI;
                  _priceup.classList.add("w30px", "h30px", "f_wh", "bg_bk", "br_30");
                  _priceup.addEventListener('click', function(event) {
                      valueup(_priceup.dataset.inputclass, _priceup.dataset.setclass);
                  });
                  _priceup.innerHTML = "+";
                  _flex3.appendChild(_priceup);            
              
              _wrap2.appendChild(_flex3);
              
              var _flex4 = document.createElement('div');
              _flex4.classList.add("toflex", "align-items_center", "mg-t_1rm", "pd-l-20px");
        
                var _addcart = document.createElement('button');
                _addcart.dataset.handle = data[i].handle;
                _addcart.dataset.variantId = data[i].variantId;
                _addcart.dataset.quantity = "1";
                _addcart.dataset.saveForLater ="false"
                _addcart.dataset.customerId = ""
                _addcart.classList.add('mxpr-favorites-cart-add');
                _addcart.onclick =function() {
                    handleAddToCart(this);
                };
                var _class = "btn_" + capturedI;
                _addcart.classList.add("btn_sizing", _class);
  
                var _addcart_img = document.createElement('img');
                _addcart_img.src = cartImage;
                _addcart.appendChild(_addcart_img);
            
              _flex4.appendChild(_addcart);
      
              var _delete = document.createElement('input');
              _delete.classList.add("delete", "btn_box", "mg-l_1rm");
              _delete.type = "image";
              _delete.src = deleteImage;    
              _delete.onclick = () => favorite_delete(capturedI);
              _flex4.appendChild(_delete); 
              _wrap2.appendChild(_flex4);
              _wrap.appendChild(_wrap2);
              
            }(i));
   
          _flex.appendChild(_wrap);
          
        setbox.appendChild(_flex);
  
    }
    
	} else {
        nodata();
    }
      
    } else {
        nodata();
    }


    function nodata() {

        var p = document.createElement('p');
        p.innerHTML = "まだお気に入りアイテムがありません";
        setbox.appendChild(p);
      
    }
      
    function favorite_delete(position) {
        const favorites = JSON.parse(localStorage.getItem('mxpr-favorites')) || [];
        var _array = [];
        for (var q = 0; q < data.length; q ++) {
            if (position != q) {
              _array.push(data[q]);
            }
        } 
        localStorage.setItem('mxpr-favorites', JSON.stringify(_array));
        location.reload();
    }

    function inputcheck(_cl, _this) {
        var t = document.querySelector(_this);
        var n = String(t.value).replace(/[^0-9]/g, '');
		if (n == "") {
			t.value = 1;
		} else {
			t.value = Number(n);
		}
        mxpr_set_value(t.value, _cl);
	}

	// 値を増やす
	function valueup(d,_class) {
        var d = document.querySelector(d);
        var n = Number(d.value) + 1;
		d.value = n;
        mxpr_set_value(n, _class);
	}
	
	// 値を減らす
	function valuedown(_get, _class) {
        var d = document.querySelector(_get);
		var _set = Math.max(1, Number(d.value) - 1);
		d.value = _set;
        mxpr_set_value(_set, _class);
	}
	
	//mxpr-favorites-cart-add
	function mxpr_set_value(_value, _class) {
		var _mxpr = document.querySelector(_class);
        if (_mxpr != undefined && _mxpr != null) {
			_mxpr.dataset.quantity = _value;
		}
	}

    // カートに登録
    window.handleAddToCart = async (button) => {
      const saveForLater = button.dataset.saveForLater;
      const variantId = button.dataset.variantId;
      const quantity = button.dataset.quantity;
      if(saveForLater == "true"){
        const handle = button.dataset.handle;
        const customerId = button.dataset.customerId;
        if(customerId){
          await removeFavorite(handle, variantId, customerId);
        }else{
          const favorites = JSON.parse(localStorage.getItem('mxpr-favorites')) || [];
          const index = favorites.findIndex(favorite => favorite.variantId == variantId);
          favorites.splice(index, 1);
          localStorage.setItem('mxpr-favorites', JSON.stringify(favorites));
        }  
      }

      var formData = {
          items: [
              {
                  id: variantId,
                  quantity: quantity,
                  properties: {} 
              }
          ] 
      };
      
      fetch('/cart/add.js', {
          method: 'POST',
          headers: {'dataType': 'json','Content-Type': 'application/json'},
          body: JSON.stringify(formData)
      })
      .catch((error) => {
          console.error('Error:', error);
      });

      window.location.reload(true);
      window.alert("カートに追加しました");
    }

    window.addEventListener('unload', () => {

      var _input = document.querySelectorAll('.curtaddinput');            
      for (var i = 0; i < _input.length; i ++) {
          _input[i].value = 1;  
      }
      
    });
